import { Button, FormControl, FormHelperText, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import styles from "./Fileuploader.module.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";

const Fileuploader = (props) => {
  const { label, trigger } = props;

  const [files, setFiles] = useState([null]);
  const [dirty, setDirty] = useState(false);

  const handleFiles = (event, index) => {
    const _file = event.target.files[0];
    // const filename = _file.name + "_" + new Date().getTime().toString();
    let filenames = _file.name.split(".");
    filenames.splice(filenames.length - 1, 0, "_" + new Date().getTime().toString());
    filenames[filenames.length - 1] = "." + filenames[filenames.length - 1];
    const filename = filenames.join("");
    const tid = new Date().getTime();
    let fs = files;
    fs[index] = {
      file: _file,
      data: {
        originalName: _file.name,
        filename: filename,
      },
    };
    if (files[files.length - 1] != null) {
      fs.push(null);
    }
    setFiles([...fs]);
    event.target.value = "";
  };

  const handleRemoveFile = (index) => {
    let fs = files;
    _.pullAt(fs, index);
    if (fs.length <= 0) {
      fs.push(null);
    }
    setFiles([...fs]);
  };

  useEffect(() => {
    let _value = files.map((file) => {
      return file ? file : null;
    });
    _value.splice(_value.length - 1, 1);
    props.setValue(_value.length !== 0 ? _value : null);
    if (dirty) {
      trigger();
    } else {
      setDirty(true);
    }
  }, [files]);

  // const api = {};
  const api = { handleFiles, handleRemoveFile };

  return (
    <div className="render-comp">
      <FormControl variant="standard" sx={{ width: "100%" }} error={props.error}>
        <div className={`${styles.container}`}>
          <div className="title-div">
            <h4>{label}</h4>
          </div>
          <input type="hidden" id={props.id} name={props.id} value={props.value} />
          {files.map((file, index) => {
            const key = _.uniqueId("fileitem_");
            return <FileItems key={key} file={file} index={index} api={api} />;
          })}
          <FormHelperText>{props.helperText}</FormHelperText>
        </div>
      </FormControl>
    </div>
  );
};

const FileItems = (props) => {
  const { index } = props;
  const { file, data } = props.file || {};
  const { handleFiles, handleRemoveFile } = props.api;
  const { t } = useTranslation();
  return (
    <div className={styles.fileitem}>
      <div>
        <Button
          sx={{
            minWidth: "120px !important",
          }}
          variant="contained"
          disableElevation
          component="label"
        >
          {t("Browse")}
          <input type="file" hidden onChange={(event) => handleFiles(event, index)} />
        </Button>
        <p className={file != null ? "activated" : ""}>{file && file.name ? (data && data.url ? file.name : file.name) : t("Upload a file")}</p>
        {(index === 0 && file == null) || file == null ? null : (
          <div className="cancel-btn">
            <IconButton onClick={() => handleRemoveFile(index)}>
              <ClearIcon />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default Fileuploader;
